import * as AT from '@/constants/ActionTypes';

export const actionsChangingMainDateStore = [
    AT.MAIN_DATE_CHANGE_CUSTOM_DATE,
    AT.MAIN_DATE_CHANGE_MODE,
    AT.MAIN_DATE_CHANGE_MODE_AND_DATE,
    AT.MAIN_DATE_MOVE_LEFT,
    AT.MAIN_DATE_MOVE_RIGHT,
    AT.MAIN_DATE_MOVE_TO_DATE,
]